// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.hamburger[data-v-4e6f274c] {\n  display: inline-block;\n  vertical-align: middle;\n  font-size: 16px;\n  color: #fff;\n}\n", ""]);
// Exports
module.exports = exports;
